export default __webpack_public_path__ + "./images/ga.fc3c38ac.png";